import Carousel from 'react-bootstrap/Carousel';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'react-bootstrap';
import '../../Styles/Common/HeroSlider.scss';
import { FaChevronCircleLeft, FaChevronCircleRight } from 'react-icons/fa';

function HeroSlider() {
    return (
        <Carousel
            nextIcon={
                <FaChevronCircleRight
                    color="#007bff"
                    style={{
                        fontSize: '4rem',
                        opacity: 1,
                    }}
                />
            }
            prevIcon={
                <FaChevronCircleLeft
                    color="#007bff"
                    style={{
                        fontSize: '4rem',
                        opacity: 1,
                    }}
                />
            }
        >
            <Carousel.Item className="hero-item gradient-overlay">
                <img
                    className="d-block w-100 hero-img img-right"
                    src="https://images-jp-prod.nyc3.cdn.digitaloceanspaces.com/Images/Misc/promo.webp"
                    alt="Réservation de journée pédagogiques"
                    loading="eager"
                />

                <Carousel.Caption className=" hero-caption text-shadow">
                    <p>Trouvez l'activité parfaite</p>
                    <h3>
                        Profitez de l'expertise de Solution Animation pour organiser vos journées pédagogiques en toute
                        simplicité.
                    </h3>
                    <Button className="btn-round" variant="primary" href="/activites">
                        LISTE DES ACTIVITÉS
                    </Button>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item className="hero-item">
                <img
                    className="d-block w-100 hero-img"
                    src="https://images-jp-prod.nyc3.cdn.digitaloceanspaces.com/Images/Misc/IMG_5158.webp"
                    alt="Réservation de journée pédagogiques"
                    loading="eager"
                />
                <Carousel.Caption className=" hero-caption text-shadow">
                    <p>Réservation de journée pédagogiques</p>
                    <p>C'est facile!</p>
                    <Button className="btn-round" variant="primary" href="/activites">
                        LISTE DES ACTIVITÉS
                    </Button>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item className="hero-item">
                <img
                    className="d-block w-100 hero-img"
                    src="https://images-jp-prod.nyc3.cdn.digitaloceanspaces.com/Images/Misc/Katag.webp"
                    alt="Organisation de parascolaires clé en main"
                    loading="eager"
                />
                <Carousel.Caption className=" hero-caption text-shadow">
                    <p>Organisation de parascolaires clé en main !</p>
                    <Button className="btn-round" variant="primary" href="/activites">
                        LISTE DES ACTIVITÉS
                    </Button>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item className="hero-item">
                <img
                    className="d-block w-100 hero-img"
                    src="https://images-jp-prod.nyc3.cdn.digitaloceanspaces.com/Images/Misc/ClubFy.webp"
                    alt="Service aux fournisseurs, simplifiez votre gestion"
                    loading="eager"
                />
                <Carousel.Caption className=" hero-caption text-shadow">
                    <p>Service aux fournisseurs, simplifiez votre gestion !</p>
                    <Button className="btn-round" variant="primary" href="/activites">
                        LISTE DES ACTIVITÉS
                    </Button>
                </Carousel.Caption>
            </Carousel.Item>
        </Carousel>
    );
}

export default HeroSlider;
